$(document).ready(() => {
  initSocialShare()
})

function initSocialShare() {
  const elements = document.querySelectorAll(".social-share")

  if (elements.length === 0) {
    return
  }

  let activeList = null

  const onClickOutside = (e) => {
    const isClickInside = activeList.contains(e.target)

    if (!isClickInside) {
      activeList.closest(".social-share").classList.remove("social-share--open")
      setActiveList(null)
    }
  }

  const setActiveList = (list) => {
    activeList = list

    if (list) {
      setTimeout(() => document.addEventListener("click", onClickOutside))
    } else {
      document.removeEventListener("click", onClickOutside)
    }
  }

  const showSharePopup = (e) => {
    e.preventDefault()

    const width = 700
    const height = 600
    const element = e.target
    const px = Math.floor(((screen.availWidth || 1366) - width) / 2)
    const py = Math.floor(((screen.availHeight || 768) - height) / 2)

    const popup = window.open(
      element.href,
      "social",
      `width=${width},height=${height},left=${px},top=${py},location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1`,
    )

    if (popup) {
      popup.focus()
      e.preventDefault()
    }
  }

  for (const element of elements) {
    const toggleButton = element.querySelector(".social-share__toggle")
    const closeButton = element.querySelector(".social-share__close")
    const list = element.querySelector(".social-share__list")
    const links = list.querySelectorAll("a")

    for (const link of links) {
      link.onclick = showSharePopup
    }

    toggleButton.addEventListener("click", (e) => {
      e.preventDefault()

      const isActive = element.classList.toggle("social-share--open")
      setActiveList(isActive ? list : null)
    })

    closeButton.addEventListener("click", (e) => {
      e.preventDefault()

      element.classList.remove("social-share--open")
      setActiveList(null)
    })
  }
}
